<template>
  <div class="success-change-password">
    <slot name="txtBefore">
      <h2>VIELEN DANK!</h2>
      <p>Ihr Password wurde erfolgreich geändert.</p>
    </slot>
    <Stepper
      @prev="prev()"
      :show-next="false"
    >
      <template v-slot:btnPrev><slot name="btnPrevThankYou">zurück</slot></template>
    </Stepper>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import processSteps from '../../../../../mixins/processSteps'
import Stepper from '../../../../generic/Stepper.vue'
import { mapMutations } from 'vuex'

export const stepName = 'success'

export default {
  name: 'ThankYouChangePassword',
  components: {
    Stepper
  },
  mixins: [
    processSteps(stepName, stepName, stepName) // do no jump by default. configure steps by props of processStep
  ],
  methods: {
    ...mapMutations('changePassword', [
      'changeStep'
    ]),
    next () {
      this.changeStep({ step: this.nextStep })
    },
    prev () {
      this.changeStep({ step: this.previousStep })
    }
  }
}
</script>
